var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    staticClass: "event-card",
    attrs: {
      "width": "390",
      "max-width": "100%"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, 'v-card', _vm.$attrs, false), [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "src": _vm.image + '.png',
      "width": "100%",
      "aspect-ratio": 390 / 317
    }
  }), _c('v-img', {
    staticClass: "event-card__active event-card__active--img mx-auto",
    attrs: {
      "src": _vm.image + '-active.svg',
      "width": "100%",
      "aspect-ratio": 390 / 317
    }
  }), _c('v-img', {
    staticClass: "event-card__active event-card__active--text mx-auto",
    attrs: {
      "src": _vm.image + '-active-text.svg',
      "width": "100%",
      "aspect-ratio": 390 / 317
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }